(() => {
  const init = picker => {
    if (picker.dataset.initialized === 'true') return;
    picker.dataset.initialized = 'true';

    const sectionId = picker.dataset.sectionId;
    const root = picker.closest('[data-product-handle]');
    const variantsNode = document.getElementById(`LeafSockVariants-${sectionId}`);
    const optionsNode = picker.querySelector('[data-ls-bundle-options]');
    const rows = picker.querySelector('[data-ls-bundle-rows]');
    const form = picker.querySelector('[data-ls-bundle-form]');
    const addButton = picker.querySelector('[data-ls-add]');
    const message = picker.querySelector('[data-ls-bundle-message]');
    const fallbackId = picker.querySelector('[data-ls-bundle-fallback-id]');
    const fallbackQuantity = picker.querySelector('[data-ls-bundle-fallback-quantity]');
    if (!variantsNode || !optionsNode || !rows || !form || !addButton) return;

    const variants = JSON.parse(variantsNode.textContent || '[]');
    const optionData = JSON.parse(optionsNode.textContent || '{}');
    const moneyFormat = window.Shopify?.currency?.active || 'USD';
    const planButtons = [...picker.querySelectorAll('[data-bundle-count]')];
    const mainPrice = root?.querySelector('[data-ls-price]');
    const mainComparePrice = root?.querySelector('[data-ls-compare-price]');
    const stickyPrice = root?.querySelector('[data-ls-sticky-price]');
    let pairCount = Number(picker.querySelector('[data-bundle-count].is-selected')?.dataset.bundleCount || 4);
    let selections = [];

    const money = cents => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: moneyFormat }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const initialVariant = variants.find(variant => String(variant.id) === String(optionData.initialVariantId)) || variants.find(variant => variant.available) || variants[0];
    const optionNames = Array.isArray(optionData.names) ? optionData.names : [];
    const optionValues = Array.isArray(optionData.values) ? optionData.values : [];
    const sizeIndex = optionNames.findIndex(name => /size/i.test(name));
    const colorIndex = optionNames.findIndex(name => /colou?r/i.test(name));
    const colorSwatches = {
      'Navy': '#27366d',
      'Beige': '#ddceaf',
      'Black': '#151716',
      'White': '#f8faf8',
      'Classic Black': '#151716',
      'Classic White': '#ffffff',
      'Gray': '#8b918e',
      'Cranberry': '#8d2139',
      'Pink': '#e6aebc',
      'Khaki & Cream': 'linear-gradient(90deg,#8b9270 0 50%,#eee8d8 50%)',
      'Cream & Taupe': 'linear-gradient(90deg,#eee8d8 0 50%,#a38f7a 50%)'
    };
    let openColorSelect = null;

    const swatchFor = value => colorSwatches[value] || '#d8ddd9';

    const closeColorMenu = wrapper => {
      if (!wrapper) return;
      const trigger = wrapper.querySelector('[data-color-trigger]');
      const menu = wrapper.querySelector('[role="listbox"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
      wrapper.classList.remove('opens-up');
      if (openColorSelect === wrapper) openColorSelect = null;
    };

    const closeOtherColorMenus = except => {
      if (openColorSelect && openColorSelect !== except) closeColorMenu(openColorSelect);
    };

    const findVariant = values => variants.find(variant => variant.options.every((option, index) => option === values[index]));

    const syncGallery = variant => {
      const mediaId = variant?.featured_media?.id;
      if (!root || !mediaId) return;
      const thumb = root.querySelector(`[data-media-id="${mediaId}"]`);
      if (thumb) thumb.click();
    };

    const updateMainPrice = resolved => {
      if (resolved.length !== pairCount) {
        if (mainPrice) mainPrice.textContent = '—';
        if (stickyPrice) stickyPrice.textContent = 'Select available options';
        if (mainComparePrice) {
          mainComparePrice.hidden = true;
          mainComparePrice.textContent = '';
        }
        return;
      }
      const regular = resolved.reduce((total, variant) => total + Number(variant?.price || 0), 0);
      if (!regular) return;
      let finalPrice = regular;
      let comparePrice = 0;
      if (pairCount === 1) {
        const variantCompare = Number(resolved[0]?.compare_at_price || 0);
        if (variantCompare > regular) comparePrice = variantCompare;
      } else {
        finalPrice = Math.round(regular / 2);
        comparePrice = regular;
      }
      if (mainPrice) mainPrice.textContent = money(finalPrice);
      if (stickyPrice) stickyPrice.textContent = money(finalPrice);
      if (mainComparePrice) {
        mainComparePrice.hidden = comparePrice <= finalPrice;
        mainComparePrice.textContent = comparePrice > finalPrice ? money(comparePrice) : '';
      }
    };

    const collect = () => {
      const resolved = selections.map(values => findVariant(values));
      let valid = true;
      [...rows.querySelectorAll('[data-bundle-row]')].forEach((row, index) => {
        const variant = resolved[index];
        const status = row.querySelector('[data-row-status]');
        const unavailable = !variant || !variant.available;
        row.classList.toggle('is-unavailable', unavailable);
        if (status) status.textContent = unavailable ? 'This combination is currently unavailable.' : '';
        if (unavailable) valid = false;
      });
      addButton.disabled = !valid;
      addButton.textContent = valid ? 'ADD TO CART' : 'CHECK UNAVAILABLE PAIRS';
      if (resolved[0]) {
        fallbackId.value = resolved[0].id;
        syncGallery(resolved[0]);
      }
      fallbackQuantity.value = String(pairCount);
      updateMainPrice(resolved.filter(Boolean));
      return valid ? resolved : [];
    };

    const makeNativeSelect = (rowIndex, optionIndex, preferredValue) => {
      const select = document.createElement('select');
      select.setAttribute('aria-label', `Pair ${rowIndex + 1} ${optionNames[optionIndex] || `Option ${optionIndex + 1}`}`);
      select.dataset.bundleOption = String(optionIndex);
      if (optionIndex === sizeIndex) select.className = 'ls-bundle__size-select';
      (optionValues[optionIndex] || []).forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        option.selected = value === preferredValue;
        select.appendChild(option);
      });
      select.addEventListener('change', event => {
        selections[rowIndex][optionIndex] = event.currentTarget.value;
        collect();
      });
      return select;
    };

    const makeColorSelect = (rowIndex, optionIndex, preferredValue) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'ls-bundle__color-select';
      wrapper.dataset.colorSelect = '';

      const select = makeNativeSelect(rowIndex, optionIndex, preferredValue);
      select.classList.add('ls-bundle__native-color');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'ls-bundle__color-trigger';
      trigger.dataset.colorTrigger = '';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', `Pair ${rowIndex + 1} color`);

      const triggerSwatch = document.createElement('span');
      triggerSwatch.className = 'ls-bundle__color-swatch';
      triggerSwatch.setAttribute('aria-hidden', 'true');
      const triggerLabel = document.createElement('span');
      triggerLabel.className = 'ls-bundle__color-label';
      const chevron = document.createElement('span');
      chevron.className = 'ls-bundle__color-chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = '▾';
      trigger.append(triggerSwatch, triggerLabel, chevron);

      const menu = document.createElement('div');
      menu.className = 'ls-bundle__color-menu';
      menu.id = `LeafSockColorOptions-${sectionId}-${rowIndex}`;
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', `Pair ${rowIndex + 1} color options`);
      menu.hidden = true;
      trigger.setAttribute('aria-controls', menu.id);

      const options = (optionValues[optionIndex] || []).map(value => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'ls-bundle__color-option';
        option.dataset.colorValue = value;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', String(value === select.value));
        const swatch = document.createElement('span');
        swatch.className = 'ls-bundle__color-swatch';
        swatch.style.setProperty('--ls-swatch', swatchFor(value));
        swatch.setAttribute('aria-hidden', 'true');
        const label = document.createElement('span');
        label.textContent = value;
        option.append(swatch, label);
        menu.appendChild(option);
        return option;
      });

      const syncVisual = () => {
        triggerLabel.textContent = select.value;
        triggerSwatch.style.setProperty('--ls-swatch', swatchFor(select.value));
        options.forEach(option => {
          const selected = option.dataset.colorValue === select.value;
          option.classList.toggle('is-active', selected);
          option.setAttribute('aria-selected', String(selected));
        });
      };

      const openMenu = focusDirection => {
        closeOtherColorMenus(wrapper);
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        wrapper.classList.remove('opens-up');
        const rect = wrapper.getBoundingClientRect();
        const roomBelow = window.innerHeight - rect.bottom;
        const roomAbove = rect.top;
        if (roomBelow < Math.min(menu.scrollHeight + 12, 272) && roomAbove > roomBelow) wrapper.classList.add('opens-up');
        openColorSelect = wrapper;
        if (focusDirection) {
          const selectedIndex = Math.max(0, options.findIndex(option => option.dataset.colorValue === select.value));
          const targetIndex = focusDirection === 'last' ? options.length - 1 : selectedIndex;
          options[targetIndex]?.focus();
        }
      };

      trigger.addEventListener('click', () => {
        if (menu.hidden) openMenu();
        else closeColorMenu(wrapper);
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          closeColorMenu(wrapper);
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openMenu(event.key === 'ArrowUp' ? 'last' : 'selected');
        }
      });

      options.forEach((option, index) => {
        option.addEventListener('click', () => {
          select.value = option.dataset.colorValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncVisual();
          closeColorMenu(wrapper);
          trigger.focus();
        });
        option.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeColorMenu(wrapper);
            trigger.focus();
            return;
          }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const delta = event.key === 'ArrowDown' ? 1 : -1;
            options[(index + delta + options.length) % options.length]?.focus();
            return;
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            options[event.key === 'Home' ? 0 : options.length - 1]?.focus();
          }
        });
      });

      select.addEventListener('change', syncVisual);
      wrapper.append(select, trigger, menu);
      syncVisual();
      return wrapper;
    };

    const makeSelect = (rowIndex, optionIndex, preferredValue) => optionIndex === colorIndex
      ? makeColorSelect(rowIndex, optionIndex, preferredValue)
      : makeNativeSelect(rowIndex, optionIndex, preferredValue);

    const renderRows = () => {
      const previous = selections.map(values => [...values]);
      selections = Array.from({ length: pairCount }, (_, index) => previous[index] || [...(initialVariant?.options || [])]);
      rows.replaceChildren();
      selections.forEach((values, rowIndex) => {
        const row = document.createElement('div');
        row.className = 'ls-bundle__row';
        row.dataset.bundleRow = String(rowIndex);
        const label = document.createElement('span');
        label.className = 'ls-bundle__row-label';
        label.textContent = `Pair ${rowIndex + 1}`;
        row.appendChild(label);
        const orderedIndexes = [sizeIndex, colorIndex].filter(index => index >= 0);
        if (!orderedIndexes.length) orderedIndexes.push(...optionNames.map((_, index) => index).slice(0, 2));
        orderedIndexes.forEach(optionIndex => row.appendChild(makeSelect(rowIndex, optionIndex, values[optionIndex])));
        const status = document.createElement('span');
        status.className = 'ls-bundle__row-status';
        status.dataset.rowStatus = '';
        status.setAttribute('aria-live', 'polite');
        row.appendChild(status);
        rows.appendChild(row);
      });
      collect();
    };

    planButtons.forEach(button => button.addEventListener('click', () => {
      pairCount = Number(button.dataset.bundleCount || 1);
      planButtons.forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', String(selected));
      });
      renderRows();
    }));

    document.addEventListener('click', event => {
      if (openColorSelect && !openColorSelect.contains(event.target)) closeColorMenu(openColorSelect);
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      const resolved = collect();
      if (!resolved.length) return;
      const grouped = new Map();
      resolved.forEach(variant => grouped.set(String(variant.id), (grouped.get(String(variant.id)) || 0) + 1));
      const items = [...grouped.entries()].map(([id, quantity]) => ({ id: Number(id), quantity }));
      const initialText = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'ADDING…';
      message.classList.remove('is-error');
      try {
        const response = await fetch(picker.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).description || 'Unable to add this bundle.');
        window.dispatchEvent(new CustomEvent('leafsock:cart:open', { detail: { trigger: addButton } }));
        addButton.disabled = false;
        addButton.textContent = initialText;
      } catch (error) {
        message.textContent = error.message || 'Unable to add this bundle. Please try again.';
        message.classList.add('is-error');
        addButton.disabled = false;
        addButton.textContent = initialText;
      }
    });

    renderRows();
  };

  const start = () => document.querySelectorAll('[data-ls-bundle-picker]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
